module.exports = __webpack_public_path__ + "img/ReleaseNotes.e5dd04dc.png";